/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, Inject} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import {FabMessageService} from '@fabric/components/message';

@Component({
    selector: 'app-update-pop-up',
    templateUrl: './update-pop-up.component.html',
    styleUrls: ['./update-pop-up.component.scss'],
    standalone: false
})
export class UpdatePopUpComponent {
  attributeForm: FormGroup;
  title = 'Update';
  currentValueToUpdate: string;
  maxLength: number;
  hidePreview = false;
  showCharCount = false;
  saveButtonText = 'Commit Change';

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: any,
              public dialogRef: MatDialogRef<UpdatePopUpComponent>,
              public snackBar: FabMessageService) {
    if (data) {
      if (!data.title || !data.currentValueToUpdate || !data.maxLength || data.hidePreview === undefined) {
        this.dialogRef.close();
      }
      this.title = data.title;
      this.currentValueToUpdate = data.currentValueToUpdate;
      this.hidePreview = data.hidePreview;
      this.maxLength = data.maxLength;
      this.showCharCount = data.showCharCount;
      if (data.saveButtonText) {
        this.saveButtonText = data.saveButtonText;
      }
    }

    this.attributeForm = new FormGroup({
      currentValue: new FormControl(),
      newValue: new FormControl('', [Validators.required])
    });
  }

  /**
   * Close popup window.
   */
  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * Return new value to preview changes.
   */
  previewChanges(): void {
    this.dialogRef.close({
      data: {
        isPreviewChange: true,
        newValue: this.attributeForm.controls.newValue.value
      }
    });
  }

  /**
   * Return new value to commit changes.
   */
  commitChanges(): void {
    this.dialogRef.close({
      data: {
        isPreviewChange: false,
        newValue: this.attributeForm.controls.newValue.value
      }
    });
  }

}


